import { Alert, AlertTitle, Button, Link } from "@mui/material";
import { useState } from "react";
import { GLOBAL_CONFIGURATION } from "../../constants";

export default function DeliveryInfoBox(props) {
  const { alwaysShowMore } = props;
  const [readMore, setReadMore] = useState(alwaysShowMore === true);

  if (GLOBAL_CONFIGURATION.deliveryInformationCode === "KLINGENBERG") {
    return (
      <Alert variant="outlined" severity="info">
        <AlertTitle>Delivery service</AlertTitle>
        <p>
          We offer a limited delivery service for guests at Klingenberg Hotel.
          If you are a guest you can order anything from our menu, and select to
          delivered. Our delivery service run{" "}
          <b>once a day, between 21:00 and 22:00.</b>
        </p>

        {readMore && (
          <>
            <p>You can order at any time.</p>
            <p>
              If you are not available in your room, the products will be placed
              inside your room. Cold food, drinks and items from our breakfast
              menu will be placed in the refrigerator inside your room.
            </p>
            <p>
              If you order hot items (burger, pizza etc.), please confirm in the
              order comment if you are available between the hours of 21:00 and
              22:00 or if we can leave the items.
            </p>
            <p>
              If you don't want your items delivered, or you need something at
              any other time of the day, you can select the "pick up in store"
              option. The store is located 2 minute walk from the hotel. You'll
              receive a text message when the order is ready for pickup.
            </p>

            {GLOBAL_CONFIGURATION.deliveryInformationMap && (
              <Link
                href={GLOBAL_CONFIGURATION.deliveryInformationMap}
                target="_blank"
              >
                Show directions to the store
              </Link>
            )}
          </>
        )}
        {!readMore && (
          <>
            <p>
              You can order at any time, and you can of course pick up your
              order in store at any time....
            </p>
            <Button
              onClick={() => setReadMore(true)}
              color="inherit"
              variant="outlined"
            >
              Read more
            </Button>
          </>
        )}
      </Alert>
    );
  }

  return <></>;
}
